<mat-chip
  [matTooltip]="textInput.value || placeholders[0] || ''"
  (click)="$event.stopPropagation()"
  (focus)="$event.stopPropagation()"
  [disabled]="loading"
  [removable]="
    (isChipOptional() ||
      isChipPreselected() ||
      isChipChiningParams() ||
      isChipDefault()) &&
    !loading
  "
  class="selected-chip"
  (removed)="remove(selectedData)"
>
  <label class="has-float-label">
    <input
      #textInput
      [style.width.px]="getInputWidth(textInput.value.toString().length, label)"
      class="chip-input"
      attr.data-testid="cis_text_{{
        selectedData?.name?.toLowerCase()?.replace(' ', '_')
      }}"
      (click)="$event.stopPropagation()"
      (focus)="$event.stopPropagation()"
      [formControl]="longText"
      (keydown)="$event.stopImmediatePropagation()"
      [placeholder]="placeholders[0]"
      [readonly]="isChipChiningParams() || isChipLock()"
    />
    <div #label class="label">{{ selectedData?.name ?? '' | translate }}</div>
  </label>

  @if ( isChipOptional() || isChipPreselected() || isChipChiningParams() ||
  isChipDefault() ) {
  <mat-icon
    matChipRemove
    attr.data-testid="cis_text_{{
      selectedData?.name?.toLowerCase()?.replace(' ', '_')
    }}_btn_cancel"
    [style.cursor]="loading ? 'context-menu' : 'pointer'"
    >cancel
  </mat-icon>
  } @if (isChipMandatory()) {
  <mat-icon
    attr.data-testid="cis_text_{{
      selectedData?.name?.toLowerCase()?.replace(' ', '_')
    }}_icon_mandatory"
    style="cursor: default"
    >push_pin</mat-icon
  >
  } @if (isChipLock()) {
  <mat-icon
    attr.data-testid="cis_text_{{
      selectedData?.name?.toLowerCase()?.replace(' ', '_')
    }}_icon_locked"
    style="cursor: default"
    >lock</mat-icon
  >
  }
</mat-chip>
